"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableKpiCreatePanelItem = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_ext_1 = require("@gooddata/sdk-ui-ext");
var DraggableCreatePanelItem_1 = require("../DraggableCreatePanelItem");
var dragItem = {
    type: "kpi-placeholder",
    size: {
        gridHeight: sdk_ui_ext_1.KPI_WIDGET_SIZE_INFO_DEFAULT.height.default,
        gridWidth: sdk_ui_ext_1.KPI_WIDGET_SIZE_INFO_DEFAULT.width.default,
    },
};
/**
 * @internal
 */
exports.DraggableKpiCreatePanelItem = function (_a) {
    var CreatePanelItemComponent = _a.CreatePanelItemComponent, WrapCreatePanelItemWithDragComponent = _a.WrapCreatePanelItemWithDragComponent, disabled = _a.disabled;
    return (react_1.default.createElement(DraggableCreatePanelItem_1.DraggableCreatePanelItem, { Component: CreatePanelItemComponent, WrapCreatePanelItemWithDragComponent: WrapCreatePanelItemWithDragComponent, disabled: disabled, dragItem: dragItem, hideDefaultPreview: false }));
};
//# sourceMappingURL=DraggableKpiCreatePanelItem.js.map